import type { CSSProperties, PropsWithChildren, Ref } from "react";
import classNames from "classnames";
import css from "./Card.module.scss";
import { CardSection } from "./CardSection";

interface Props {
    className?: string;
    withTabs?: boolean;
    onClick?: () => void;
    label?: string;
    labelClassName?: string;
    stacked?: boolean;
    fullPage?: boolean;
    sharpEdges?: boolean;
    noBorder?: boolean;
    style?: CSSProperties;
}
export const Card = ({
    children,
    className,
    withTabs,
    label,
    labelClassName,
    stacked,
    fullPage,
    sharpEdges,
    noBorder,
    ref,
    ...otherProps
}: PropsWithChildren<Props> & { ref?: Ref<HTMLDivElement> }) => (
    <div
        ref={ref}
        className={classNames(css.card, className, {
            [css.withTabs]: withTabs,
            [css.stacked]: stacked ?? Boolean(label),
            [css.sharpEdges]: sharpEdges,
            [css.fullPage]: fullPage,
            [css.noBorder]: noBorder,
        })}
        {...otherProps}
    >
        {label && (
            <CardSection className={classNames(css.label, labelClassName)}>
                {label}
            </CardSection>
        )}
        {children}
    </div>
);
